export default{
    selectType:"请选择类别",
    options:{
        "changePassword":'修改密码'
    },
    //如果您没有密码，初始密码为000000，您可以设置新的密码
    changPasswordTip:''
}